export default __webpack_public_path__ + "static/media/campus1.6347b82b.jfif";